import { DefaultValue } from 'recoil';

const isRecoilDefaultValue = (candidate: any): candidate is DefaultValue => {
  if (candidate instanceof DefaultValue) return true;
  return false;
};

export default isRecoilDefaultValue;
